import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import { RootState } from '../redux/root';

const FeesSendFormReimbursementIssue = ({ fees, setSendDisabled }) => {
  const [dataIsMissing, setDataIsMissing] = useState<boolean>(false);
  const permitFees = useSelector((s:RootState) => s.fees.permitFees);

  useEffect(() => {
    const _fees = permitFees.filter(pf => fees.indexOf(pf.id) > -1);
    _fees.forEach(item => {
        if (item.name === 'Reimbursement') {
            if (!item.file || Number(item.amount) === 0) {
                setDataIsMissing(true);
                setSendDisabled(true);
            }
          }
    });
  }, [fees]);

  if (!dataIsMissing) return null;

  return (
    <Callout role="alert">
      <IconWrap>
        <WarningRoundedIcon />
      </IconWrap>
      <Body>
        <Title>Reimbursement requirements not met</Title>
        <Message>
          Every reimbursement fee needs an attached file and an amount greater than $0.00.
        </Message>
      </Body>
    </Callout>
  );
};

export default FeesSendFormReimbursementIssue;

const Callout = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 0 0 16px;
  padding: 14px 16px;
  background: var(--warning-50);
  border: 1px solid var(--warning-200, var(--warning-100));
  border-radius: 10px;
  text-align: left;
`;

const IconWrap = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--warning-100);

  svg {
    width: 18px;
    height: 18px;
    color: var(--warning-600, var(--warning-500));
  }
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

const Title = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--warning-700, var(--warning-600));
`;

const Message = styled.div`
  font-size: 0.8125rem;
  line-height: 1.45;
  color: var(--neutral-700);
`;
